import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    position: 'absolute',
    zIndex: 10,
    fontFamily: 'Times',
    marginTop: 2,
    letterSpacing: 0,
    whiteSpace: 'pre-line',
  },
  rootAlignCenter: {
    transform: 'translateX(-50%)',
  },
});

const DocumentPreviewFillText = ({
  name,
  getText,
  x,
  y,
  width,
  documentPrintWidth,
  documentPrintHeight,
  documentWidth,
  align,
  fontStyle,
  fontWeight,
  fontSize,
  lineHeight,
  business,
  order,
  patient,
  payment,
  appInfo,
  fieldsShift,
  classes,
}) => {
  const maxWidth = width || documentPrintWidth - x;
  const text = getText({
    business,
    ...order ? {
      facility: order.Facility,
      patient: order.Patient,
      prescriber: order.Prescriber,
    } : {},
    ...patient ? {
      patient,
    } : {},
    payment,
    appInfo,
  });
  return (
    <div
      id={name}
      className={classNames(classes.root, {
        [classes.rootAlignCenter]: align === 'center',
      })}
      style={{
        left: `${((x + fieldsShift.x) / documentPrintWidth) * 100}%`,
        top: `${((y + fieldsShift.y) / documentPrintHeight) * 100}%`,
        maxWidth: `${((maxWidth / documentPrintWidth) * 100) + 1}%`,
        fontStyle,
        fontWeight,
        // fontSize: `${((fontSize / 10) * 1.1)}vw`,
        fontSize: (fontSize / 2.834646) * (documentWidth / documentPrintWidth),
        lineHeight: lineHeight,
      }}
    >
      {text}
    </div>
  );
};

DocumentPreviewFillText.propTypes = {
  name: PropTypes.string.isRequired,
  getText: PropTypes.func.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  documentPrintWidth: PropTypes.number.isRequired,
  documentPrintHeight: PropTypes.number.isRequired,
  fontStyle: PropTypes.oneOf(['normal', 'italic']),
  fontWeight: PropTypes.oneOf(['normal', 'bold']),
  fontSize: PropTypes.number,
  lineHeight: PropTypes.number,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootAlignCenter: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentPreviewFillText.defaultProps = {
  width: null,
  align: 'left',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: 10,
  lineHeight: 1.2,
  business: {},
};

export default withStyles(styles)(DocumentPreviewFillText);



// WEBPACK FOOTER //
// ./src/components/common/DocumentPreviewFillForm/DocumentPreviewFillText.js